var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTelegramPrimaryLinear3232 = function SvgIconTelegramPrimaryLinear3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-telegram-primary-linear-32*32_svg__a)",
    d: "M27.613 4.87s2.59-1.01 2.373 1.443c-.07 1.01-.718 4.545-1.222 8.368l-1.727 11.327s-.144 1.66-1.44 1.948c-1.294.288-3.236-1.01-3.596-1.299-.288-.216-5.396-3.463-7.195-5.05-.504-.433-1.08-1.298.072-2.308l7.554-7.215c.863-.865 1.727-2.885-1.87-.433l-10.074 6.854s-1.151.722-3.31.072l-4.677-1.443S.775 16.052 3.725 14.97c7.195-3.39 16.045-6.853 23.887-10.1h.001Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-telegram-primary-linear-32*32_svg__a",
    x1: 13.098,
    x2: 17.404,
    y1: 12.771,
    y2: 33.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })))));
};
export default SvgIconTelegramPrimaryLinear3232;